module.exports = __webpack_public_path__ + "img/CM-DJ-24-Ford-Established.fe13bc46.jpg";